/**
 * Lightweight toast notification utility.
 * Replaces blocking window.alert() with non-blocking, auto-dismissing toasts.
 *
 * Usage:
 *   import { toast } from '../utils/toast';
 *   toast.success('Saved successfully!');
 *   toast.error('Something went wrong.');
 *   toast.info('Processing...');
 */

const CONTAINER_ID = '__toast_container__'
const TOAST_DURATION = 4000  // ms

function getContainer() {
  let container = document.getElementById(CONTAINER_ID)
  if (!container) {
    container = document.createElement('div')
    container.id = CONTAINER_ID
    Object.assign(container.style, {
      position: 'fixed',
      top: '1rem',
      right: '1rem',
      zIndex: '9999',
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem',
      maxWidth: '24rem',
      pointerEvents: 'none',
    })
    document.body.appendChild(container)
  }
  return container
}

const BG_COLORS = {
  success: '#16a34a',
  error: '#dc2626',
  info: '#2563eb',
  warning: '#d97706',
}

function show(message, type = 'info') {
  const container = getContainer()

  const el = document.createElement('div')
  Object.assign(el.style, {
    background: BG_COLORS[type] || BG_COLORS.info,
    color: '#fff',
    padding: '0.75rem 1rem',
    borderRadius: '0.5rem',
    boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
    fontSize: '0.875rem',
    lineHeight: '1.4',
    opacity: '0',
    transition: 'opacity 0.2s ease',
    pointerEvents: 'auto',
    wordBreak: 'break-word',
  })
  el.textContent = message
  container.appendChild(el)

  // Fade in
  requestAnimationFrame(() => { el.style.opacity = '1' })

  // Auto-dismiss
  setTimeout(() => {
    el.style.opacity = '0'
    setTimeout(() => el.remove(), 220)
  }, TOAST_DURATION)
}

export const toast = {
  success: (msg) => show(msg, 'success'),
  error: (msg) => show(msg, 'error'),
  info: (msg) => show(msg, 'info'),
  warning: (msg) => show(msg, 'warning'),
}

export function showToast(message, type = 'info') {
  show(message, type)
}
